<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros-caderno-servicos 
            :cadernosImportados="cadernosImportados" 
            ref="cadernoServicosParams" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-caderno-servicos"
            color="green"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarCadernoServicos()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import CadernoServicosService from '@/services/RelatorioCadernoServicosService';
import ImportacaoCadernoServicosService from "@/services/parametrosComCa/CadernosServicosService";

export default {
  name: 'CadernoServicosEdit',
  
  components: {
    ParametrosCadernoServicos: () => import('@/components/cadernoServicos/ParametrosCadernoServicos.vue')
  },
  
  mounted() {
    this.getCadernosImportados();
  },

  data() {
    return {
      loading: false,
      cadernosImportados: []
    };
  },

  methods: {
    getCadernosImportados() {
      this.loading = true;

      ImportacaoCadernoServicosService.getCadernosServicos()
        .then(response => {
          this.cadernosImportados = [];
          response.data.cadernos.forEach(element => {
            this.cadernosImportados.push({
              id: element.id,
              nome: element.nome
            });
          });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao buscar os Cadernos de Seviços Importados.', '', { position: 'topRight' });
        })
        .finally(() => this.loading = false);
    },

    salvarCadernoServicos() {
      this.loading = true;
      const data = this.$refs.cadernoServicosParams.exportData();

      console.log(data);
      
      CadernoServicosService.salvarCadernoServicos(data)
        .then(() => {
          this.$router.push({ name: 'Caderno Servicos Histórico' });
          this.$toast.success('Caderno de Serviços salvo com sucesso.', '', { position: 'topRight' });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao salvar o Caderno de Seviços.', '', { position: 'topRight' });
        })
        .finally(() => this.loading = false);
    }
  }
};
</script>